export const theme = {
  colorScheme: "light",
  bg: "#f3efe6",
  ink: "#1c1914",
  muted: "#6b6458",
  surface: "#fffdf8",
  border: "#d9d0bf",
  accent: "#0f6b5c",
  accentSoft: "#d7efe9",
  danger: "#9b2c2c",
  display: 'Georgia, "Times New Roman", ui-serif, serif',
  sans: 'system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: 'ui-monospace, "SF Mono", Menlo, Consolas, monospace',
  radius: "10px",
  shadow: "0 18px 50px rgba(28, 25, 20, 0.08)",
  listItemBg: "#fffcf7",
  badgeBg: "#efe8db",
  detailPreBg: "#f7f2e8",
  codeBg: "#f1ebdf",
  strong: "#11100d",
} as const;

export type AppTheme = typeof theme;

declare module "styled-components" {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface DefaultTheme extends AppTheme {}
}
